import dayjs from "dayjs";


import { SelectOptions, AutocompleteOptions } from "common/assets/data/options";
import { formatReceivedDate } from "./utility";

export function randomAdjective() {
  const adjectives = [
    'Abundant',
    'Accurate',
    'Addicted',
    'Adorable',
    'Adventurous',
    'Afraid',
    'Aggressive',
    'Alcoholic',
    'Alert',
    'Aloof',
    'Ambitious',
    'Ancient',
    'Angry',
    'Bad',
    'Bashful',
    'Beautiful',
    'Belligerent',
    'Beneficial',
    'Best',
    'Big',
    'Bitter',
    'Bizarre',
    'Black',
    'Blue',
    'Boring',
    'Brainy',
    'Calm',
    'Capable',
    'Careful',
    'Careless',
    'Caring',
    'Cautious',
    'Charming',
    'Cheap',
    'Cheerful',
    'Chubby',
    'Clean',
    'Clever',
    'Clumsy',
    'Damaged',
    'Dangerous',
    'Dark',
    'Deep',
    'Defective',
    'Delicate',
    'Delicious',
    'Depressed',
    'Determined',
    'Different',
    'Dirty',
    'Disgusting',
    'Dry',
    'Dusty',
    'Early',
    'Educated',
    'Efficient',
    'Elderly',
    'Elegant',
    'Embarrassed',
    'Empty',
    'Encouraging',
    'Enthusiastic',
    'Excellent',
    'Exciting',
    'Expensive',
    'Fabulous',
    'Fair',
    'Faithful',
    'Famous',
    'Fancy',
    'Fantastic',
    'Fast',
    'Fearful',
    'Fearless',
    'Fertile',
    'Filthy',
    'Foolish',
    'Forgetful',
    'Friendly',
    'Funny',
    'Gentle',
    'Glamorous',
    'Glorious',
    'Gorgeous',
    'Graceful',
    'Grateful',
    'Great',
    'Greedy',
    'Green',
    'Handsome',
    'Happy',
    'Harsh',
    'Healthy',
    'Heavy',
    'Helpful',
    'Hilarious',
    'Historical',
    'Horrible',
    'Hot',
    'Huge',
    'Humorous',
    'Hungry',
    'Ignorant',
    'Illegal',
    'Imaginary',
    'Impolite',
    'Important',
    'Impossible',
    'Innocent',
    'Intelligent',
    'Interesting',
    'Jealous',
    'Jolly',
    'Juicy',
    'Juvenile',
    'Kind',
    'Large',
    'Legal',
    'Light',
    'Literate',
    'Little',
    'Lively',
    'Lonely',
    'Loud',
    'Lovely',
    'Lucky',
    'Macho',
    'Magical',
    'Magnificent',
    'Massive',
    'Mature',
    'Mean',
    'Messy',
    'Modern',
    'Narrow',
    'Nasty',
    'Naughty',
    'Nervous',
    'New',
    'Noisy',
    'Nutritious',
    'Obedient',
    'Obese',
    'Obnoxious',
    'Old',
    'Overconfident',
    'Peaceful',
    'Pink',
    'Polite',
    'Poor',
    'Powerful',
    'Precious',
    'Pretty',
    'Proud',
    'Quick',
    'Quiet',
    'Rapid',
    'Rare',
    'Red',
    'Remarkable',
    'Responsible',
    'Rich',
    'Romantic',
    'Royal',
    'Rude',
    'Scintillating',
    'Secretive',
    'Selfish',
    'Serious',
    'Sharp',
    'Shiny',
    'Shocking',
    'Short',
    'Shy',
    'Silly',
    'Sincere',
    'Skinny',
    'Slim',
    'Slow',
    'Small',
    'Soft',
    'Spicy',
    'Spiritual',
    'Splendid',
    'Strong',
    'Successful',
    'Sweet',
    'Talented',
    'Tall',
    'Tense',
    'Terrible',
    'Terrific',
    'Thick',
    'Thin',
    'Tiny',
    'Tactful',
    'Tailor-made',
    'Take-charge',
    'Tangible',
    'Tasteful',
    'Tasty',
    'Teachable',
    'Teeming',
    'Tempean',
    'Temperate',
    'Tenable',
    'Tenacious',
    'Tender',
    'Tender-hearted',
    'Terrific',
    'Testimonial',
    'Thankful',
    'Thankworthy',
    'Therapeutic',
    'Thorough',
    'Thoughtful',
    'Ugly',
    'Unique',
    'Untidy',
    'Upset',
    'Victorious',
    'Violent',
    'Vulgar',
    'Warm',
    'Weak',
    'Wealthy',
    'Wide',
    'Wise',
    'Witty',
    'Wonderful',
    'Worried',
    'Young',
    'Youthful',
    'Zealous',
  ];

  return adjectives[randomNumber(0, adjectives.length - 1)];
}

export function randomAutocompleteOption(key: string) {
  return AutocompleteOptions()[key][randomNumber(0, AutocompleteOptions()[key].length - 1)].code;
}

export function randomBoolean() {
  return Math.random() >= 0.5 ? true : false;  
}

export function randomDate(start: Date = new Date(1960, 0, 1), end: Date = new Date(2000, 0, 1)) : any {
  return dayjs(formatReceivedDate(new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())))).format("YYYY-MM-DD");
}

export function randomNumber(start: number, end: number) {
  return start + Math.floor(Math.random() * (end - start));
}

export function randomSelectOption(key: string) {
  return SelectOptions()[key][randomNumber(0, SelectOptions()[key].length - 1)].value;
}

export function randomString(n: number) {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  
  let result: Array<string> = [];
  for (let i = 0; i < n; i++) {
    result.push(alphabet.charAt(Math.floor(Math.random() * alphabet.length)));
  }

  return result.join('');
}

export function randomNoun() {
  const nouns = [
    'Actor',
    'Gold',
    'Painting',
    'Advertisement',
    'Grass',
    'Parrot',
    'Afternoon',
    'Greece',
    'Pencil',
    'Airport',
    'Guitar',
    'Piano',
    'Ambulance',
    'Hair',
    'Pillow',
    'Animal',
    'Pizza',
    'Answer',
    'Helicopter',
    'Planet',
    'Apple',
    'Helmet',
    'Plastic',
    'Army',
    'Holiday',
    'Portugal',
    'Australia',
    'Potato',
    'Balloon',
    'Horse',
    'Queen',
    'Banana',
    'Hospital',
    'Quill',
    'Battery',
    'House',
    'Rain',
    'Beach',
    'Hydrogen',
    'Rainbow',
    'Beard',
    'Ice',
    'Raincoat',
    'Bed',
    'Insect',
    'Refrigerator',
    'Belgium',
    'Insurance',
    'Restaurant',
    'Boy',
    'Iron',
    'River',
    'Branch',
    'Island',
    'Rocket',
    'Breakfast',
    'Jackal',
    'Room',
    'Brother',
    'Jelly',
    'Rose',
    'Camera',
    'Jewellery',
    'Russia',
    'Candle',
    'Jordan',
    'Sandwich',
    'Car',
    'Juice',
    'School',
    'Caravan',
    'Kangaroo',
    'Scooter',
    'Carpet',
    'King',
    'Shampoo',
    'Cartoon',
    'Kitchen',
    'Shoe',
    'China',
    'Kite',
    'Soccer',
    'Church',
    'Knife',
    'Spoon',
    'Crayon',
    'Lamp',
    'Stone',
    'Crowd',
    'Lawyer',
    'Sugar',
    'Daughter',
    'Leather',
    'Sweden',
    'Death',
    'Library',
    'Teacher',
    'Denmark',
    'Lighter',
    'Telephone',
    'Diamond',
    'Lion',
    'Television',
    'Dinner',
    'Lizard',
    'Tent',
    'Disease',
    'Lock',
    'Thailand',
    'Doctor',
    'London',
    'Tomato',
    'Dog',
    'Lunch',
    'Toothbrush',
    'Dream',
    'Machine',
    'Traffic',
    'Dress',
    'Magazine',
    'Train',
    'Magician',
    'Truck',
    'Manchester',
    'Uganda',
    'Eggplant',
    'Market',
    'Umbrella',
    'Egypt',
    'Match',
    'Van',
    'Elephant',
    'Microphone',
    'Vase',
    'Energy',
    'Monkey',
    'Vegetable',
    'Engine',
    'Morning',
    'Vulture',
    'England',
    'Motorcycle',
    'Wall',
    'Evening',
    'Nail',
    'Whale',
    'Eye',
    'Napkin',
    'Window',
    'Family',
    'Needle',
    'Wire',
    'Finland',
    'Nest',
    'Xylophone',
    'Fish',
    'Nigeria',
    'Yacht',
    'Flag',
    'Night',
    'Yak',
    'Flower',
    'Notebook',
    'Zebra',
    'Football',
    'Ocean',
    'Zoo',
    'Forest',
    'Oil',
    'Garden',
    'Fountain',
    'Orange',
    'Gas',
    'France',
    'Oxygen',
    'Girl',
    'Furniture',
    'Oyster',
    'Glass',
    'Garage',
    'Ghos',
  ];

  return nouns[randomNumber(0, nouns.length - 1)];
}